module.exports = __webpack_public_path__ + "img/104.9295c36b.jpg";